import { GLOBAL_HANDLER_ID_ATTRIBUTE, REFERENCE_ID_SELECTOR } from 'consts';
import { isTruthy } from '@ardoq/common-helpers';
import { REFERENCE_ID_ATTRIBUTE } from '@ardoq/global-consts';
import { getNodeUrlFieldValues } from '@ardoq/graph';
import { HasUrlFieldValuesById } from './types';
import { UrlFieldValueList } from './UrlFieldValueList';

const urlFieldValuesPopover =
  ({
    urlFieldValuesByComponentId,
    urlFieldValuesByReferenceId,
  }: HasUrlFieldValuesById) =>
  (element: Element | null) => {
    const componentId = element
      ?.closest(`.component[${GLOBAL_HANDLER_ID_ATTRIBUTE}]`)
      ?.getAttribute(GLOBAL_HANDLER_ID_ATTRIBUTE);

    const referenceIds =
      element
        ?.closest(REFERENCE_ID_SELECTOR)
        ?.getAttribute(REFERENCE_ID_ATTRIBUTE)
        ?.split(',') ??
      [
        element
          ?.closest(`.integration[${GLOBAL_HANDLER_ID_ATTRIBUTE}]`)
          ?.getAttribute(GLOBAL_HANDLER_ID_ATTRIBUTE),
      ].filter(isTruthy);

    const urlFieldValues = getNodeUrlFieldValues(
      componentId,
      referenceIds,
      urlFieldValuesByComponentId,
      urlFieldValuesByReferenceId
    );
    if (!urlFieldValues.length) {
      return null;
    }
    return (
      <UrlFieldValueList element={element} urlFieldValues={urlFieldValues} />
    );
  };
export { urlFieldValuesPopover };
